import { render, staticRenderFns } from "./BaseSelectOption.vue?vue&type=template&id=545e184b&scoped=true&"
import script from "./BaseSelectOption.vue?vue&type=script&lang=js&"
export * from "./BaseSelectOption.vue?vue&type=script&lang=js&"
import style0 from "./BaseSelectOption.vue?vue&type=style&index=0&id=545e184b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e184b",
  null
  
)

export default component.exports